import { render } from "./ApprovalWorkspacePage.vue?vue&type=template&id=224c6e71&scoped=true"
import script from "./ApprovalWorkspacePage.vue?vue&type=script&lang=js"
export * from "./ApprovalWorkspacePage.vue?vue&type=script&lang=js"

import "./ApprovalWorkspacePage.vue?vue&type=style&index=0&id=224c6e71&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224c6e71"]])

export default __exports__